<div class="row justify-content-center">
  <div class="col-12 col-lg-9">
    <div class="preview-summary row">
      <div class="col-sm-auto">
        <div *appHasAnyAuthority="[authority.Admin, authority.Teacher, authority.Staff]" class="mb-2">
          <span [hidden]="!user?.status" class="status-badge status-active mb-2">{{ 'ACTIVE' | translate }}</span>
          <span [hidden]="user?.status" class="status-badge status-inactive mb-2">{{ 'INACTIVE' | translate }}</span>
        </div>
        <h2 class="preview-title">{{ user?.user?.firstName }} {{ user?.user?.lastName }}</h2>
        <div class="d-flex align-items-center pr-3">
          <i class="ftmi-user mr-1"></i>
          {{ user?.role?.code }}
        </div>
        <div class="d-flex align-items-center pr-3">
          <i class="ftmi-email mr-1"></i>
          {{ user?.user?.email }}
        </div>
        <div *ngIf="user?.graduationYear" class="d-flex align-items-center pr-3">
          <i class="ftmi-user-graduation mr-1"></i>
          {{ user?.graduationYear }}
        </div>
      </div>
      <div *appHasAnyAuthority="[Authority.Admin, Authority.Teacher, authority.Staff]" class="col-sm-auto ml-sm-auto">
        <button class="btn btn-outline-primary btn-sm" (click)="onEditUser()" [appTooltip]="'EDIT' | translate">
          {{ 'EDIT' | translate }} <i class="icon icon-right ftmi-edit"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="col-12 col-lg-9">
    <div class="meta-panel mb-5">
      <div class="meta-panel-header">
        <div class="title">{{ 'CURRENT_SCHOOL_YEAR_DATA' | translate }}</div>

        <div class="select-flex-dropdown mb-2" dropdown>
          <div class="select-flex-toggle" *ngIf="selectedFlex" dropdownToggle role="button">
            <div class="flex-name text-truncate">{{ selectedFlex.name }}</div>
            <div class="flex-time">{{ selectedFlex.flexTimeStr }}</div>
          </div>
          <app-flex-drop-down
            [shouldShowAllFlexs]="true"
            (flexsLoaded)="onFlexsLoaded($event)"
            (selectedFlexChange)="onSelectedFlexChange($event)"
          ></app-flex-drop-down>
        </div>
      </div>
      <div *ngIf="teacherMetrics" class="my-3">
        <div class="row">
          <div class="col-12 col-lg-auto">
            <span>Total Activities</span>
            <h3 class="legend-total">{{ teacherMetrics.activities.total }}</h3>
          </div>
          <div class="col">
            <div *ngIf="teacherMetrics.activities.total !== 0" class="mt-3 mb-2 d-flex">
              <div class="chart-container">
                <canvas
                  baseChart
                  [chartType]="appConfig.ChartType"
                  [options]="appConfig.ChartOptions"
                  [data]="chartData.activities.data"
                  [labels]="chartData.activities.labels"
                  [colors]="chartData.activities.colors"
                >
                </canvas>
              </div>
              <div class="ml-3">
                <ul class="chart-legend">
                  <li
                    *ngFor="let item of chartData.activities.labels; index as i"
                    [className]="applyLabelClass(i, chartData.activities.colors)"
                  >
                    <span>{{ item }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col">
            <div *ngIf="teacherMetrics.activities.total !== 0" class="mt-3 mb-2 d-flex">
              <div class="chart-container">
                <canvas
                  baseChart
                  [chartType]="appConfig.ChartType"
                  [options]="appConfig.ChartOptions"
                  [data]="chartData.studentAttendance.data"
                  [labels]="chartData.studentAttendance.labels"
                  [colors]="chartData.studentAttendance.colors"
                >
                </canvas>
              </div>
              <div class="ml-3">
                <ul class="chart-legend">
                  <li
                    *ngFor="let item of chartData.studentAttendance.labels; index as i"
                    [className]="applyLabelClass(i, chartData.studentAttendance.colors)"
                  >
                    <span>{{ item }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div *ngIf="teacherMetrics.activities.total === 0" class="col">
            <div class="alert justify-content-center">
              {{ 'NO_ACTIVITIES_AND_ATTENDANCE' | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 col-lg-9">
    <tabset class="filter-tabs">
      <tab
        id="topRecurringActivities"
        heading="{{ 'TOP_RECURRING_ACTIVITIES' | translate }}"
        (selectTab)="onSelectTab($event)"
      >
        <div *ngIf="activeTab === 'topRecurringActivities'">
          <app-employee-activity-data-list
            [user]="user"
            [activities]="activities?.topRecurringActivitiesCollection"
          ></app-employee-activity-data-list>
        </div>
      </tab>
      <tab
        id="topAttendedActivities"
        heading="{{ 'TOP_ATTENDED_ACTIVITIES' | translate }}"
        (selectTab)="onSelectTab($event)"
      >
        <div *ngIf="activeTab === 'topAttendedActivities'">
          <app-employee-activity-data-list
            [user]="user"
            [activities]="activities?.topAttendedActivitiesCollection"
          ></app-employee-activity-data-list>
        </div>
      </tab>
    </tabset>
  </div>
</div>
